import controller from './vd-checkbox.controller'
import template from './vd-checkbox.html'

const CheckboxComponent = {
  bindings: {
    label: '@',
    description: '@',
    disabled: '<',
    mixed: '=',
  },
  require: {
    ngModelCtrl: 'ngModel',
  },
  template,
  controller,
}

export default CheckboxComponent
